<select id="{{id}}"
        [(ngModel)]="selectedOption"
        name="{{name}}"
        (ngModelChange)="onOptionChange()">
  <option *ngFor="let option of options | keys"
          [ngValue]="option">
    {{options[option] ? options[option].name : 'N/A'}}
  </option>
</select>
